import { render, staticRenderFns } from "./EmojiPickerContainer.vue?vue&type=template&id=a72c9ba6&scoped=true&"
import script from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"
export * from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPickerContainer.vue?vue&type=style&index=0&id=a72c9ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72c9ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
